import React, { useState } from 'react';
import { ListBase, ListProps } from 'react-admin';
import { useLocation } from 'react-router-dom';
import ServiceItemsListPage from './List/ServiceItemsListPage';
import { ServiceItemsListConfig } from './List/types';

const config: ServiceItemsListConfig = {
    detailPath: '/service_items',
    changeInstancesPath: '/change_instances',
    applicationsResource: 'applications',
    servicesResource: 'consumer_services',
    partyField: {
        label: 'Service Owner',
        /* The light list leaves out service_owner_team, so in practice this is
           the service's owner; the property is read first for the reads that
           do carry it. Either shape is {id, name}. */
        team: (record) => record.service_owner_team ?? record.service?.owner,
        pov: 'serviceowner',
    },
    // rows first, as the service owner's list already opens — the card view is
    // still a switch away in the filter panel
    defaultView: 'list',
};

const ServiceItemsList = (props: ListProps) => {
    /**
     * ?application_id= is how the applications page sends someone here. It
     * names a filter this list already owns, so it opens as a filter *value* —
     * on its own column header, and clearable — rather than as a permanent
     * filter with no control behind it.
     *
     * Read once: react-admin rewrites the search string when list params
     * change, and this has to survive that.
     */
    const location = useLocation();
    const [applicationId] = useState(() => new URLSearchParams(location.search).get('application_id'));

    return (
        // page size is the batch the infinite scroll fetches
        <ListBase
            sort={{ field: 'id', order: 'DESC' }}
            filter={{ light: true }}
            perPage={25}
            filterDefaultValues={applicationId ? { application_id: applicationId } : undefined}
            {...props}
        >
            <ServiceItemsListPage config={config} />
        </ListBase>
    );
};

export default ServiceItemsList;
